import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogComponent } from "@components/dialog/dialog.component";
import { CacheService } from "src/app/modules/cache/cache.service";
import { EstateType } from "../contract/Enum/portfolio.enum";

@Injectable({
  providedIn: "root"
})
export class DuplicateCheckService {
  private readonly dialog = inject(MatDialog);
  private readonly cacheService = inject(CacheService);

  showDuplicateCheckDialog() {
    return this.createConfirmationDialog().afterClosed();
  }

  getShortCache(addressId: number, estateType: EstateType) {
    return this.cacheService.existsCache(addressId, estateType);
  }

  private createConfirmationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      title: "Module.DuplicatesCheck.Dialog.LoadFromCacheTitle",
      message: "Module.DuplicatesCheck.Dialog.Description",
      confirmText: "Module.DuplicatesCheck.Dialog.LoadFromCache",
      cancelText: "Module.DuplicatesCheck.Dialog.NewRequest",
      maxWidth: "600px",
      hasBackdrop: true
    };

    return this.dialog.open<DialogComponent, MatDialogConfig, boolean>(DialogComponent, dialogConfig);
  }
}
